import { memo } from 'react';
import { OSelect, OTextArea, OTooltip } from '@src/shared';

import useCreatePoll from './useCreatePoll';

import { FaPlus } from 'react-icons/fa';
import { FaRegTrashCan } from 'react-icons/fa6';

import { TIME_OPTIONS } from './createPoll.constants';

const CreatePoll = ({ isHidden = false }: { isHidden: boolean }) => {
  const {
    pollOptions,
    pollQuestion,
    addButtonTooltip,
    selectedPollTime,
    selectedVoteType,
    createButtonTooltip,
    isAddButtonDisabled,
    isCreateButtonDisabled,
    handleCreatePoll,
    handleAppendOption,
    handleRemoveOption,
    handleSelectPollTime,
    handleChangeQuestion,
    handleChangeVoteType,
    handleChangeOptionText,
  } = useCreatePoll();

  return (
    <div className={`create-poll-container ${isHidden ? 'hidden' : ''}`}>
      <div className="poll-vote-option">
        <label className="label">Type</label>
        <div className="vote-options-container">
          <div className="radio-container">
            <label className="radio-label">
              <input
                type="radio"
                value="SINGLE"
                checked={selectedVoteType === 'SINGLE'}
                onChange={() => handleChangeVoteType('SINGLE')}
              />
              Single vote
            </label>
          </div>
          <div className="radio-container">
            <label className="radio-label">
              <input
                type="radio"
                value="MULTIPLE"
                checked={selectedVoteType === 'MULTIPLE'}
                onChange={() => handleChangeVoteType('MULTIPLE')}
              />
              Multiple votes
            </label>
          </div>
        </div>
      </div>
      <div className="time-container">
        <label className="label">Ends after</label>
        <OSelect
          items={TIME_OPTIONS}
          alignItems="start"
          onChange={(value) => handleSelectPollTime(value)}
          selectedValue={selectedPollTime}
        />
      </div>
      <OTextArea
        label="Question"
        placeholder="Enter question"
        value={pollQuestion}
        maxLength={255}
        onChange={(e) => handleChangeQuestion(e.target.value)}
      />
      {/* Options */}
      <div className="poll-options-container">
        <label className="label">Options</label>
        <div className="options-container">
          {!!pollOptions.length &&
            pollOptions.map((option, index) => (
              <div key={index} className="option-container">
                <input
                  className="option-input"
                  placeholder="Enter option"
                  value={option}
                  maxLength={100}
                  onChange={(e) => handleChangeOptionText(e.target.value, index)}
                />
                <OTooltip title="Remove option">
                  <div className="icon-container" onClick={() => handleRemoveOption(index)}>
                    <FaRegTrashCan />
                  </div>
                </OTooltip>
              </div>
            ))}
          <OTooltip title={addButtonTooltip}>
            <button
              className={`crate-option-btn ${isAddButtonDisabled ? 'option-add-disabled' : ''}`}
              onClick={!isAddButtonDisabled ? handleAppendOption : undefined}
            >
              <FaPlus />
              Add new option
            </button>
          </OTooltip>
        </div>
      </div>
      {/* Create poll button */}
      <div className="footer-container">
        <OTooltip title={createButtonTooltip}>
          <button
            className={`crate-poll-btn  ${isCreateButtonDisabled ? 'btn-disabled' : ''}`}
            onClick={() => !isCreateButtonDisabled && handleCreatePoll()}
          >
            Create Poll
          </button>
        </OTooltip>
      </div>
    </div>
  );
};

export default memo(CreatePoll);
